import { render, staticRenderFns } from "./MCP.vue?vue&type=template&id=d6a6802a&scoped=true"
import script from "./MCP.vue?vue&type=script&lang=js"
export * from "./MCP.vue?vue&type=script&lang=js"
import style0 from "./MCP.vue?vue&type=style&index=0&id=d6a6802a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a6802a",
  null
  
)

export default component.exports